import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { CommonService } from '../commons/services/common.service';
import { environment } from '../../environments/environment';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit {

  @ViewChild('document', { static: true }) document;
  @ViewChild('msgCommon', { static: true }) msgCommon;
  moment = new Date();
  nomSociete: String = '';
  env: any = {};
  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public barChartLabels: String[] = [];
  public barChartType: String = 'bar';
  public barChartLegend: Boolean = false;

  public barChartData: any[] = [
    { data: [], label: '' }
  ];

  public barChartLabelsEcobenne: String[] = [];
  public barChartDataEcobenne: any[] = [
    { data: [], label: '' }
  ];

  data = {};
  paramHolding = {};
  public colorHome = '#f9f9f9';
  icon = `<i class="fa fa-angle-down fa-2x" aria-hidden="true"></i>`;
  textSite = '';

  public color: any[] = [
    { // dark grey
      backgroundColor: 'rgba(77,83,96,0.2)',
      borderColor: 'rgba(77,83,96,1)',
      pointBackgroundColor: 'rgba(77,83,96,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,83,96,1)'
    }
  ];
  public lineChartColors: Array<any> = [
    { // grey
      backgroundColor: 'rgba(243, 243, 243, 0.25)',
      borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ];

  user: any = {};
  nomSite = '';
  listeSite = [];
  site: any = {};
  isChangeSite: Boolean = false;
  authorizedHoldingMenus = {}

  tuiles = [];
  // backCouleur = '#376194';
  backCouleur = '#5393e0';
  colorLibelle = '#1b2f48';
  colorValeur = '#376194';
  nonConfSelected: any = { id: 0 };

  constructor(public common: CommonService, protected app: AppComponent) {
    this.common.doSomethingAfterGetWarDeployer.subscribe(data => {
      if (data) {
        console.log('après chargement getWar');

        if (this.isChangeSite) {
          this.initialisationParam()
          this.isChangeSite = false;
          this.getDashboard();
          console.log('après chargement isChangeSite');
        } else {
          this.isChangeSite = false;
          this.gridTuile();
          console.log('après chargement !isChangeSite');
        }
      }
    });
  }

  ngOnInit() {
    this.common.initValeurLocalStorage();
    // if (!this.common.websocketPlaning) {
    //   this.common.socketPlanningEcobennes();
    // }


    let societe = this.common.local.getObject('paramSociete') || this.common.paramSociete;
    this.listeSite = this.common.local.getObject('listeSite') || [];
    this.listeSite.forEach(elt => {
      elt.libelleObjetEntite = elt.nom;
    });
    const stylePage = this.common.local.getObject('stylePage');
    if (stylePage) {
      this.colorHome = stylePage['couleurHome'] && stylePage['couleurHome'] !== '' ? stylePage['couleurHome'] : this.colorHome;
    }

    societe = societe || {};
    this.common.activedModule = 0;

    if (societe.SI) {
      const nonConf = this.common.getType('typeNonConformite') || [];
      nonConf.forEach(elt => {
        const libelle = (elt.libelleObjetEntite || '').toLocaleLowerCase();
        if (libelle === 'contrat') {
          this.nonConfSelected = elt;
        }
      });
    }
    const infoUser = this.common.local.getObject('userInfo') || [];
    this.user = this.common.local.getObject('userDetail') || this.common.userDetail;
    const listeSite = this.common.local.getObject('listeSite') || [];
    const selectedSite = listeSite.filter(elt => elt.id === infoUser[2]);
    if (selectedSite.length) {
      this.site = selectedSite[0];
      this.nomSite = selectedSite[0].nom || '';
    }
    this.initialisationParam()
    this.textSite = `<div class="tooloc">  ${this.nomSite} </div> ${listeSite && listeSite.length > 1 ? this.icon : ''}`;
    const ctrl = this;
    const delay = setTimeout(() => {
      if (ctrl.common.isLoadingApp) {
        clearTimeout(delay);
        ctrl.gridTuile();
      }
    }, 500);
    ctrl.gridTuile();
    /**Debug logAngular */
    this.nomSociete = societe['nom'];
    // this.common.checkSessions();
    this.getDashboard();
    this.common.DBGestionChampFicheParametrage(1);
    this.common.docTemplate = this.document;
    this.common.msgCommon = this.msgCommon;
    this.env = environment || {};
  }

  initialisationParam() {
    let societe = this.common.local.getObject('paramSociete') || this.common.paramSociete;
    societe = societe || {};
    this.common.listParamActive = [
      {
        id: 0, title: 'Logistique', route: '/recylog/param/logistique', droit: true, visible: true, submenus: [
          {
            id: 0,
            title: 'Cubages de contenant',
            route: '/recylog/param/logistique/cubage',
            droit: false,
            visible: true
          },
          {
            id: 1,
            title: 'Familles de contenant',
            route: '/recylog/param/logistique/famille',
            droit: false,
            visible: true
          },
          { id: 2, title: 'Types de contenant', route: '/recylog/param/logistique/type', droit: false, visible: true },
          { id: 3, title: 'Contenants', route: '/recylog/param/logistique/contenant', droit: false, visible: true },
          { id: 4, title: 'Matériel', route: '/recylog/param/logistique/materiel', droit: false, visible: true },
          { id: 5, title: 'Parkings', route: '/recylog/param/logistique/parking', droit: false, visible: true },
          { id: 6, title: 'Période', route: '/recylog/param/logistique/periode', droit: false, visible: true },
          { id: 7, title: 'Ponts bascule', route: '/recylog/param/logistique/pont_bascule', droit: false, visible: true },
          {
            id: 8, title: societe.SI ? 'Qualification du partenaire' :
              'Qualification du personnel', route: '/recylog/param/logistique/qual_perso', droit: false, visible: true
          },
          {
            id: 9,
            title: 'Sous-type d\'équipement',
            route: '/recylog/param/logistique/sous_type_equipement',
            droit: false,
            visible: true
          },
          {
            id: 10,
            title: 'Sous-type de matériel',
            route: '/recylog/param/logistique/sous_type_materiel',
            droit: false,
            visible: true
          },
          {
            id: 11,
            title: 'Transporteurs',
            route: '/recylog/param/logistique/transporteur',
            droit: false,
            visible: true
          },
          {
            id: 12,
            title: 'Type d\'équipement',
            route: '/recylog/param/logistique/type_equipement',
            droit: false,
            visible: true
          },
          {
            id: 13,
            title: 'Type d\'équipement de matériel',
            route: '/recylog/param/logistique/type_equipement_mat',
            droit: false,
            visible: true
          },
          {
            id: 14,
            title: 'Types de Matériel',
            route: '/recylog/param/logistique/type_materiel',
            droit: false,
            visible: true
          },
          {
            id: 15,
            title: societe.SI ? 'Partenaire' : 'Personnel',
            route: '/recylog/param/logistique/personnel',
            droit: false,
            visible: true
          },
          {
            id: 16,
            title: 'Agence d\'interim',
            route: '/recylog/param/logistique/agence_interim',
            droit: false,
            visible: true
          },
          {
            id: 17,
            title: 'Opération bac',
            route: '/recylog/param/logistique/operation_bac',
            droit: false,
            visible: true
          },
          {
            id: 18,
            title: 'Motif indisponibilité',
            route: '/recylog/param/logistique/motif_indispo',
            droit: false,
            visible: true
          },
          { id: 19, title: 'Fournisseur', route: '/recylog/param/logistique/fournisseur', droit: true, visible: true },
          { id: 20, title: 'Mécanicien', route: '/recylog/param/logistique/mecanicien', droit: true, visible: true },
          {
            id: 21,
            title: 'Articles entretien',
            route: '/recylog/param/logistique/articles_entretien',
            droit: false,
            visible: true
          },
          {
            id: 22,
            title: 'Equipements de matériel',
            route: '/recylog/param/logistique/equipement_materiel',
            droit: false,
            visible: true
          },
          {
            id: 23,
            title: 'Types de réparations',
            route: '/recylog/param/logistique/type_reparation',
            droit: false,
            visible: true
          },
          {
            id: 24,
            title: 'Programmes d\'entretien',
            route: '/recylog/param/logistique/programme_entretien',
            droit: false,
            visible: true
          },
          {
            id: 25,
            title: 'Type de propriété',
            route: '/recylog/param/logistique/type_propriete',
            droit: false,
            visible: true
          },
          {
            id: 26,
            title: 'Zone bac',
            route: '/recylog/param/logistique/zone_bac',
            droit: false,
            visible: true
          },
          {
            id: 27,
            title: 'Zones par commune',
            route: '/recylog/param/logistique/zone_commune',
            droit: false,
            visible: true
          },
          {
            id: 28,
            title: 'Caméras',
            route: '/recylog/param/logistique/camera',
            droit: false,
            visible: true
          }, {
            id: 29,
            title: 'Motifs mission intérimaire',
            route: '/recylog/param/logistique/motifs_mission_interimaire',
            droit: false,
            visible: true
          },
          {
            id: 30,
            title: 'Tour Véhicule',
            route: '/recylog/param/logistique/tour_vehicule',
            droit: false,
            visible: true
          },
          {
            id: 31,
            title: 'Camion des transporteurs',
            route: '/recylog/param/logistique/camion_transporteur',
            droit: false,
            visible: true
          },
          {
            id: 33,
            title: 'Modulation du personnel',
            route: '/recylog/param/logistique/modulation',
            droit: false,
            visible: true
          },
          {
            id: 34,
            title: 'Exutoire',
            route: '/recylog/param/exutoire',
            droit: false,
            visible: true
          },
          {
            id: 35,
            title: 'Opération contenant',
            route: '/recylog/param/logistique/operation_contenant',
            droit: false,
            visible: true
          },
          {
            id: 36,
            title: 'Informatique embarquée',
            route: '/recylog/param/logistique/informatique_embarque',
            droit: false,
            visible: true
          },
           {
            id: 37,
            title: 'Motifs refus FIP',
            route: '/recylog/param/logistique/motif_refus_fip',
            droit: false,
            visible: true
          }
        ]
      },
      { id: 1, title: 'Arborescence Partenaire', route: '/recylog/param/MR', droit: true, visible: true },
      { id: 2, title: 'Arborescence Exutoire', route: '/recylog/param/restriction_exutoire', droit: true, visible: true },
      {
        id: 4, title: 'Article', route: '/recylog/param/article', droit: true, visible: true, submenus: [
          { id: 0, title: 'Article', route: '/recylog/param/menu-article/article', visible: true },
          { id: 1, title: 'Famille d\'article', route: '/recylog/param/menu-article/famille', visible: true },
          { id: 2, title: 'Sous-Famille', route: '/recylog/param/menu-article/sous-famille', visible: true },
          { id: 3, title: 'Axe analytique', route: '/recylog/param/menu-article/axe-analytique', visible: true },
        ]
      },
      {
        id: 7,
        title: 'Champs commerciaux supplémentaires',
        route: '/recylog/param/comm_supplementaire',
        visible: true
      },
      { id: 8, title: 'Courtiers', route: '/recylog/param/courtier', visible: true },
      { id: 11, title: 'Familles de contrat', route: '/recylog/param/famille_contrat', droit: false, visible: true },
      { id: 12, title: 'Motif refus devis', route: '/recylog/param/motif_refus_devis', droit: false, visible: true },
      {
        id: 13, title: 'Système', route: '/recylog/param/systeme', visible: true, droit: true, submenus: [
          {
            id: 0,
            title: 'Activités de la société',
            route: '/recylog/param/systeme/activite_societe',
            visible: true,
            droit: false,
          },
          { id: 1, title: 'Comptes', route: '/recylog/param/systeme/compte', visible: true, droit: false, },
          {
            id: 2,
            title: 'Profil utilisateurs',
            route: '/recylog/param/systeme/profil_user',
            visible: true,
            droit: false,
          },
          { id: 3, title: 'Service', route: '/recylog/param/systeme/service', visible: true, droit: false, },
          { id: 4, title: 'Sites', route: '/recylog/param/systeme/site', visible: true, droit: false, },
          { id: 5, title: 'Société', route: '/recylog/param/systeme/societe', visible: true, droit: false, },
          { id: 6, title: 'TVA', route: '/recylog/param/systeme/tva', visible: true, droit: false, },
          { id: 7, title: 'Utilisateurs', route: '/recylog/param/systeme/user', visible: true, droit: false, },
          {
            id: 8,
            title: 'Type de document société',
            route: '/recylog/param/systeme/type_document',
            visible: true,
            droit: false,
          },
          {
            id: 9,
            title: 'Type de paiement',
            route: '/recylog/param/systeme/type_paiement',
            visible: true,
            droit: false,
          },
          {
            id: 10,
            title: 'Widget du portail',
            route: '/recylog/param/systeme/widget_ecoportail',
            visible: true,
            droit: false,
          },
          {
            id: 11,
            title: 'Formulaires comptes Ecoportail',
            route: '/recylog/param/systeme/compte_ecoportail',
            visible: true,
            droit: false,
          },
          {
            id: 12,
            title: 'Paiement en ligne',
            route: '/recylog/param/systeme/paiement_en_ligne',
            visible: true,
            droit: false,
          },
          {
            id: 13,
            title: 'Commune',
            route: '/recylog/param/systeme/commune',
            visible: true,
            droit: false,
          },
          {
            id: 14,
            title: 'Comptes trackdechet',
            route: '/recylog/param/systeme/compteTrackDechets',
            visible: true,
            droit: false,
          }
        ]
      },
      {
        id: 14,
        title: 'Type installation 8 flux',
        route: '/recylog/param/type_instal_flux',
        droit: false,
        visible: true
      },
      {
        id: 15, title: 'Déchetterie', route: '/recylog/param/decheterrie', droit: true, visible: true, submenus: [
          {
            id: 0,
            title: 'Liste des quantités de déchet',
            route: '/recylog/param/decheterrie/quantite_dechet',
            visible: true
          },
          { id: 1, title: 'Type d\'incident', route: '/recylog/param/decheterrie/type_incident', visible: true },
          {
            id: 1,
            title: 'Type de véhicule décheterie',
            route: '/recylog/param/decheterrie/type_vehicule',
            visible: true
          },
          { id: 1, title: 'Fiche ouverture', route: '/recylog/param/decheterrie/fiche_ouverture', visible: true },
        ]
      },
      { id: 16, title: 'Activité détenteur', route: '/recylog/param/activite_detenteur', visible: true },
      {
        id: 17, title: 'Holding', route: '/recylog/param/holding', droit: false, visible: true, submenus: [
          { id: 0, title: 'Utilisateurs', route: '/recylog/param/holding/utilisateur', droit: false, visible: true },
          { id: 1, title: 'Article', route: '/recylog/param/holding/article', droit: false, visible: true },
          {
            id: 2,
            title: 'Cubages de contenant',
            route: '/recylog/param/holding/cubage',
            droit: false,
            visible: true
          },
          { id: 3, title: 'Exutoires', route: '/recylog/param/holding/exutoire', droit: false, visible: true },
          {
            id: 4,
            title: 'Familles d\'article',
            route: '/recylog/param/holding/famille_article',
            droit: false,
            visible: true
          },
          {
            id: 5,
            title: 'Familles de contenant',
            route: '/recylog/param/holding/famille_contenant',
            droit: false,
            visible: true
          },
          {
            id: 6,
            title: 'Sous-familles d\'article',
            route: '/recylog/param/holding/sous_famille_article',
            droit: false,
            visible: true
          },
          { id: 7, title: 'Transporteur', route: '/recylog/param/holding/transporteur', droit: false, visible: true },
          {
            id: 8,
            title: 'Types de contenant',
            route: '/recylog/param/holding/type_contenant',
            droit: false,
            visible: true
          },
          { id: 9, title: 'Clients', route: '/recylog/param/holding/client', droit: false, visible: true },
          { id: 10, title: 'Matériel', route: '/recylog/param/holding/materiel', droit: false, visible: true },
          { id: 11, title: 'Courtier', route: '/recylog/param/holding/courtier', droit: false, visible: true },
          {
            id: 12,
            title: 'Types d\'équipement',
            route: '/recylog/param/holding/type_equipement',
            droit: false,
            visible: true
          },
          {
            id: 13,
            title: 'Indices / Indexes',
            route: '/recylog/param/holding/indices_indexes',
            droit: false,
            visible: true
          },
          // {
          //   id: 14,
          //   title: 'Ponts bascule',
          //   route: '/recylog/param/holding/pont_bascule',
          //   droit: false,
          //   visible: true
          // },
        ]
      },
      {
        id: 18, title: 'GRC', route: '/recylog/param/grc', droit: false, visible: true, submenus: [
          { id: 0, title: 'Action RDV', route: '/recylog/param/grc/action_rdv', visible: true, droit: true },
          { id: 1, title: 'Type RDV', route: '/recylog/param/grc/type_rdv', visible: true, droit: true },
          { id: 2, title: 'Objectif RDV', route: '/recylog/param/grc/objectif_rdv', visible: true, droit: true },
        ]
      },
      { id: 19, title: 'Broyeur', route: '/recylog/param/broyeur', droit: false, visible: true },
      { id: 20, title: 'Centre VHU', route: '/recylog/param/centre_vhu', droit: false, visible: true },
      { id: 21, title: 'Rayon Stock', route: '/recylog/param/rayon_stock', droit: false, visible: true },
      {
        id: 22,
        title: 'Badges pont bascule',
        route: '/recylog/param/badges_pontbascule',
        droit: false,
        visible: true
      },
      { id: 23, title: 'Groupe de clients', route: '/recylog/param/groupe_client', droit: false, visible: true },
      { id: 24, title: 'Ressource', route: '/recylog/param/ressource', droit: false, visible: true },
      {
        id: 25,
        title: 'Gestion des chèques',
        route: '/recylog/param/gestion_cheque',
        droit: false,
        visible: true,
        submenus: [
          {
            id: 0,
            title: 'Réception d\'un lot de chèque',
            route: '/recylog/param/gestion_cheque/reception_cheque',
            visible: true,
            droit: false
          },
          {
            id: 1,
            title: 'Numéro en cours',
            route: '/recylog/param/gestion_cheque/numero_cheque',
            visible: true,
            droit: false
          },
          {
            id: 2,
            title: 'Modifier le numéro en cours',
            route: '/recylog/param/gestion_cheque/modifier_numero_cheque',
            visible: true,
            droit: false
          },
        ]
      },
      {
        id: 26,
        title: 'Augmentation des tarifs',
        route: '/recylog/param/aug_tarif',
        droit: false,
        visible: true,
        submenus: [
          {
            id: 0,
            title: 'Augmentation des prix listes',
            route: '/recylog/param/aug_tarif/prixliste',
            visible: true,
            droit: false
          },
          {
            id: 1,
            title: 'Augmentation des prix négociés',
            route: '/recylog/param/aug_tarif/prixnegocie',
            visible: true,
            droit: false
          },
          {
            id: 2,
            title: 'Augmentation des prix des contrats de facturation',
            route: '/recylog/param/aug_tarif/prixcontrat',
            visible: true,
            droit: false
          },
        ]
      },
      {
        id: 27,
        title: 'Gestion des CAP',
        route: '/recylog/param/gestion-cap',
        droit: false,
        visible: true,
        submenus: [
          {
            id: 0,
            title: 'Renouvellement des CAP',
            route: '/recylog/param/gestion-cap/renouvellement/cap',
            visible: true
          },
          {
            id: 1,
            title: 'Impression des CAP',
            route: '/recylog/param/gestion-cap/impression',
            visible: true
          },
          {
            id: 3,
            title: 'Impression des CAP en format perso',
            route: '/recylog/param/gestion-cap/impressionFormatPerso',
            visible: true
          },
          {
            id: 2,
            title: 'Extraire les CAP Client',
            appelFct: true,
            functionName: 'serviceExtraireXLSCAP',
            visible: true
          },
          {
            id: 4,
            title: 'Renouvellement des CAP DND',
            route: '/recylog/param/gestion-cap/renouvellement/capdnd',
            visible: true
          },
        ]
      },
      {
        id: 28,
        title: 'EcoGED',
        route: '/recylog/param/ecoged',
        droit: false,
        visible: true,
        submenus: [
          {
            id: 0,
            title: 'Type de demande',
            route: '/recylog/param/ecoged/type_demande',
            visible: true
          },
          {
            id: 1,
            title: 'Motif de demande non recevable',
            route: '/recylog/param/ecoged/motif_demande_nonrecevable',
            visible: true
          },
          {
            id: 2,
            title: 'Qualification de demande',
            route: '/recylog/param/ecoged/qualification_demande',
            visible: true
          },
          {
            id: 3,
            title: 'Questionnaire composteur',
            route: '/recylog/param/ecoged/questionnaire_composteur',
            visible: true
          },
        ]
      },
      {
        id: 29, title: 'Format d\'impression', route: '/recylog/param/formaPerso', droit: false, visible: true, submenus: []
      },

      {
        id: 30, title: 'Format de comptabilité', route: '/recylog/param/formaCompta', droit: false, visible: true,
        submenus: [
          {
            id: 1,
            title: 'Pièces commerciales',
            route: '/recylog/param/formaCompta/1',
            visible: true
          },
          {
            id: 5,
            title: 'Bons de commandes',
            route: '/recylog/param/formaCompta/5',
            visible: true
          },
          {
            id: 2,
            title: 'Bons d\'achat aux particuliers',
            route: '/recylog/param/formaCompta/2',
            visible: true
          },
          {
            id: 4,
            title: 'Caisses',
            route: '/recylog/param/formaCompta/4',
            visible: true
          },
          {
            id: 6,
            title: 'Clients',
            route: '/recylog/param/formaCompta/6',
            visible: true
          },
          {
            id: 3,
            title: 'Paiement',
            route: '/recylog/param/formaCompta/3',
            visible: true
          },

        ]
      },
      { id: 31, title: 'Lieux de départ', route: '/recylog/param/lieux-de-depart', droit: false, visible: true },
      { id: 32, title: 'Cycles de travail', route: '/recylog/param/cycles-travail', droit: false, visible: true },
      { id: 33, title: 'Section devis', route: '/recylog/param/section_devis', droit: false, visible: true },
      { id: 34, title: 'Frequence Import Prestataire', route: '/recylog/param/frequence_import', droit: false, visible: true },
      { id: 35, title: 'Filières de facturation', route: '/recylog/param/filiere_facturation', droit: false, visible: true },
      { id: 36, title: 'Zone provenance', route: '/recylog/param/zone_provenance', droit: false, visible: true },
      { id: 37, title: 'Compteur RH', route: '/recylog/param/compteur_rh', droit: false, visible: true },
      { id: 38, title: 'Zone de stockage', route: '/recylog/param/zone_stockage', droit: false, visible: true },
      { id: 39, title: 'Population des communes', route: '/recylog/param/population_commune', droit: false, visible: true },
      {
        id: 40, title: 'Tiers', route: '/recylog/param/tiers', droit: false, visible: true,
        submenus: [
          {
            id: 0,
            title: 'Activités des clients',
            route: '/recylog/param/activite_client',
            visible: true
          },
          {
            id: 1,
            title: 'Civilités',
            route: '/recylog/param/civilite',
            visible: true
          },
          {
            id: 2,
            title: 'Indices / Indexes',
            route: '/recylog/param/menu-indices-indexes/indices-indexes',
            visible: true
          },
          {
            id: 3,
            title: 'Indices / Indexes - Actualiser les bons',
            route: '/recylog/param/menu-indices-indexes/actualiser-bons',
            visible: true
          },
          {
            id: 4,
            title: 'Groupe d\'impression',
            route: '/recylog/param/groupe_impression',
            visible: true
          },
        ]
      },
      { id: 41, title: 'Motif Refus Ecoloc', route: '/recylog/param/motif_refus_ecoloc', droit: false, visible: true },
      {
        id: 42,
        title: 'Jours fériés pour le RDV',
        route: '/recylog/param/jours_feries',
        droit: false,
        visible: true
      }
    ];
  }

  ngAfterViewInit() {
    const infoUser = this.common.local.getObject('userInfo') || [];
    this.user = this.common.local.getObject('userDetail') || this.common.userDetail;
    const listeSite = this.common.local.getObject('listeSite') || [];
    const selectedSite = listeSite.filter(elt => elt.id === infoUser[2]);
    if (selectedSite.length) {
      this.nomSite = selectedSite[0].nom || '';
    }
  }

  // events
  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }

  getDashboard() {
    const user = this.common.local.getObject('userInfo');
    // const param = {
    //   'servlet': 'DBGestionTableauDeBord',
    //   'module': 'Recylog',
    //   'type': 'map',
    //   'compression': 'false',
    //   'data': {
    //     'SITE': {
    //       'typeParam': 'int',
    //       'valeur': user[2]
    //     },
    //     'OPERATION': {
    //       'typeParam': 'int',
    //       'valeur': 1
    //     },
    //     'CLEF_USER': {
    //       'typeParam': 'int',
    //       'valeur': user[0]
    //     },
    //   }
    // };

    // this.common.post('', { param: param }).then(datas => {
    this.data = {} // datas.data !== null ? datas.data : {};
    const data = this.data;
    const datas = { data: null }
    // data['TotalValidation'] = this.totalRetourbon();
    // data['TotalRetourBon'] = this.totalRetourbonEcobenne();
    data['TotalValidation'] = data['NOMBRE_BON_NON_VALIDES'] || 0;
    data['TotalRetourBon'] = data['NOMBRE_BON_ECOBENNE_NON_VALIDES'] || 0;

    this.barChartLabels = datas.data ? datas.data.LISTE_MOIS_BON_NON_VALIDES : [];
    this.barChartData[0].data = datas.data ? datas.data.LISTE_NOMBRE_BON_NON_VALIDES : [];
    this.barChartLabelsEcobenne = datas.data ? datas.data.LISTE_MOIS_BON_ECOBENNE_NON_VALIDES : [];
    this.barChartDataEcobenne[0].data = datas.data ? datas.data.LISTE_NOMBRE_BON_ECOBENNE_NON_VALIDES : [];
    // this.common.checkSessions();
    this.common.checkDroit();
    this.loadParamAcces();
    this.gridTuile(data);
    // });
  }

  gridTuile(data?) {
    data = data || {};
    const env = environment;
    const societe = this.common.local.getObject('paramSociete') || {};
    this.tuiles = [
      {
        libelle: 'Bac', droit: env.moduleEcobac && this.common.isPlanningBac, tuiles: [
          {
            libelle: 'Intervention', droit: this.common.isPlanningBac, valuer: 0, icon: 'bac_intervention',
            col: 1, route: '/ecobac/planning_bac'
          },
          {
            libelle: 'validation int.', droit: this.common.isEcobac && this.common.isDroitValidationEcobac, valuer: 0, icon: 'bac_validation', col: 1,
            route: '/ecobac/validation'
          },
          { libelle: 'stock', droit: this.common.isEcobac, valuer: 'NBR_BAC_STOCK', icon: 'bac_stock', col: 1, route: '/ecobac/stock_bac' },
        ]
      },
      {
        libelle: 'Bennes', droit: env.moduleEcobennes && this.common.isEcobennes, tuiles: [
          {
            libelle: 'tournées', droit: env.moduleEcobennes && this.common.isEcobennes && this.common.isTournee, valuer: 0, icon: 'tournee', col: 1,
            route: '/ecobennes/tournees'
          },
          {
            libelle: 'contenants', droit: env.moduleEcobennes && this.common.isEcobennes && this.common.isDroitCreationMouvementEcobennes, valuer: 'CONTENANT_TOTAL', icon: 'bennes_contenant', col: 1,
            route: '/ecobennes/mvt_bennes'
          },
          {
            libelle: 'planning', droit: env.moduleEcobennes && this.common.isEcobennes, valuer: 0, icon: 'bennes_planning', col: 1,
            route: '/ecobennes/planning_contenant'
          },
          {
            libelle: 'CARTE tournées', droit: env.moduleEcobennes && env.moduleEcocarto && this.common.isEcobennes && this.common.isEcoPAV, valuer: 0, icon: 'map_tournee',
            col: 1, route: '/ecobennes/cartographie'
          },
          {
            libelle: 'Geoloc chauffeurs', droit: env.moduleEcobennes && env.moduleEcocarto && this.common.isEcobennes && this.common.isCarteChauffeurs, valuer: 0, icon: 'map_chauffeur',
            col: 1, route: '/ecobennes/cartographie_chauffeur'
          },
          {
            libelle: 'retours des bons', droit:
              env.moduleEcobennes && this.common.isEcobennes && this.common.isDroitValideRetourEcobennes, valuer: 0, icon: 'bennes_retour',
            col: 1, route: '/ecobennes/retour_bons'
          },
          // {
          //   libelle: 'Prestations', droit: this.common.isPrestation, valuer: 'TotalRetourBon',
          //   icon: 'bennes_retour', col: 1, route: '/recylog/prestation'
          // },
        ]
      },
      {
        libelle: 'Praxy', droit: this.common.isPrestation, tuiles: [
          {
            libelle: 'Suivi des clients', libelleModule: 'GRC', droit: env.moduleEcocrm && this.common.isEcocrm,
            valuer: 'NBR_RDV_AUJOURDHUI', icon: 'grc_suivi', col: 1, route: '/ecocrm/planning'
          },
          {
            libelle: 'Facturation', libelleModule: 'Contrat', droit: env.moduleEcocontrat && this.common.isContratFact,
            valuer: 'NBR_CONTRAT', icon: 'contrat_fact', reverse: true, col: 1, route: '/ecocontrat/contrat'
          },
        ]
      },
      {
        libelle: 'Praxy', droit: env.moduleEcobennes && this.common.isPrestation, tuiles: [
          {
            libelle: 'Prestations', libelleModule: 'Prestations', droit: this.common.isPrestation, valuer: 'TotalRetourBon',
            icon: 'bennes_retour', col: 1, route: '/recylog/prestation'
          },
          {
            libelle: 'Prestations', libelleModule: 'ADV', droit: this.common.isPrestation, valuer: 'NBR_PREST_ADV', reverse: true,
            icon: 'bennes_retour', col: 1, route: '/recylog/adv'
          },
        ]
      },
      {
        libelle: 'Praxy', droit: this.common.isPrestation, tuiles: [
          {
            libelle: 'PRESTATIONS SANS CONTRAT', libelleModule: 'ADV CONTRAT', droit: env.moduleEcobennes && this.common.isPrestation,
            valuer: 'NBR_PREST_ADV_SANS_CONTRAT', icon: 'bennes_retour', col: 1, route: '/recylog/adv', withParam: true
          },
        ]
      },
      {
        libelle: 'GAR', droit: env.moduleEcogar && this.common.isEcogar, tuiles: [
          {
            libelle: 'Parc et  entretien', droit: env.moduleEcogar, valuer: 0, icon: 'parcentretien',
            col: 1, route: '/ecogar/parcentretien'
          },
          {
            libelle: 'Planning des moyens', droit: env.moduleEcogar && this.common.isPlanningMoyenEcogar, valuer: 0, icon: 'planning-moyens',
            col: 1, route: '/ecogar/planning-moyens'
          },
          {
            libelle: 'Planning de la maintenance', droit: env.moduleEcogar, valuer: 0, icon: 'planning-maintenance',
            col: 1, route: '/ecogar/planning'
          },
          {
            libelle: 'Validation', droit: env.moduleEcogar, valuer: "NBR_PREST_ECOGAR", icon: 'validation',
            col: 1, route: '/ecogar/validation'
          },
        ]
      },
      {
        libelle: 'GRC', droit: env.moduleEcocrm && this.common.isEcocrm && !this.common.isPrestation, tuiles: [
          {
            libelle: 'rdv', droit: env.moduleEcocrm && this.common.isEcocrm, valuer: 0, icon: 'rdv',
            col: 1, route: '/ecocrm/planning'
          },
          {
            libelle: 'Devis', droit: env.moduleEcocrm && this.common.isEcocrm, valuer: 0, icon: 'contrat_fact',
            col: 1, route: '/ecocrm/gestion_devis'
          },
          {
            libelle: 'Relance', droit: env.moduleEcocrm && this.common.isEcocrm, valuer: 0, icon: 'relance',
            col: 1, route: '/ecocrm/relance_devis'
          },
        ]
      },
      {
        libelle: 'Contrat', droit: env.moduleEcocontrat && this.common.isContratFact && !this.common.isPrestation && (this.common.isApproEcocontrat || this.common.isExpedEcocontrat || this.common.isFacturationEcocontrat), tuiles: [
          {
            libelle: 'Approvisionnement', droit: env.moduleEcocontrat && this.common.isContratFact && this.common.isApproEcocontrat, valuer: 0, icon: 'contrat_appro',
            col: 1, route: '/ecocontrat/appro'
          },
          {
            libelle: 'expédition', droit: env.moduleEcocontrat && this.common.isContratFact && this.common.isExpedEcocontrat, valuer: 0, icon: 'contrat_expedition',
            col: 1, route: '/ecocontrat/expedition'
          },
          {
            libelle: 'Facturation', droit: env.moduleEcocontrat && this.common.isContratFact && this.common.isFacturationEcocontrat, valuer: 'NBR_CONTRAT', icon: 'contrat_fact',
            col: 1, route: '/ecocontrat/contrat'
          },
        ]
      },
      {
        libelle: 'Fact', droit: env.moduleEcofact && this.common.isEcofact && !this.common.isPrestation, tuiles: [
          {
            libelle: 'Facturation', droit: this.common.isFactBon && this.common.isDroitBonAFacturer, valuer: 'TOTAL_BON_A_FACTURER', icon: 'fact_gestion',
            reverse: true, col: 1, route: '/ecofact/gestion_bons'
          },
          {
            libelle: 'Pro forma', droit: env.moduleEcofact && this.common.isFactBon && !this.common.isPrestation, valuer: 'TOTAL_BON_A_FACTURER', icon: 'pro_forma',
            reverse: true, col: 1, route: '/ecofact/pro_forma'
          },
          {
            libelle: 'Achats', droit: this.common.isBonachat, valuer: 0, icon: 'fact_gestion',
            col: 1, route: '/ecofact/gestion_achat'
          },
          {
            libelle: 'ventes', droit: this.common.isFacture, valuer: 0, icon: 'fact_ventes',
            col: 1, route: '/ecofact/gestion_facture'
          },
          {
            libelle: 'paiements', droit: this.common.isPaiement, valuer: 0, icon: 'fact_paiement',
            col: 1, route: '/ecofact/gestion_paie'
          },
          {
            libelle: 'Achats généraux', droit: this.common.isModuleEcoachat, valuer: 0, icon: 'fact_gestion',
            col: 1, route: '/ecofact/achats_generaux'
          },
          {
            libelle: 'Relance', droit: env.moduleEcofact && this.common.isRelance && !this.common.isPrestation, valuer: 0, icon: 'relance',
            col: 1, route: '/ecofact/relance_fact'
          },
        ]
      },
      {
        libelle: 'Loc', droit: env.moduleEcoloc && this.common.isEcoloc && !this.common.isPrestation, tuiles: [
          {
            libelle: 'Planning presta.', droit: env.moduleEcoloc && this.common.isEcoloc && !this.common.isPrestation, valuer: 'TOTAL_INDISPO_CHAUFFEUR', icon: 'loc_planning',
            col: 1, route: 'ecoloc/planning'
          },
          {
            libelle: 'Validation presta.', droit: env.moduleEcoloc && this.common.isEcoloc && !this.common.isPrestation, valuer: 'TotalValidation', icon: 'loc_validation',
            col: 1, route: 'ecoloc/validation'
          },
        ]
      },
      {
        libelle: 'Rh', droit: env.moduleEcorh && this.common.isEcorh && !this.common.isPrestation, tuiles: [
          {
            libelle: 'gestion du personnel', droit: env.moduleEcorh && this.common.isEcorh && !this.common.isPrestation,
            valuer: 0, icon: 'rh_personnel', reverse: true, col: 1, route: '/ecorh/planning'
          },
          {
            libelle: 'gestion des heures', droit: env.moduleEcorh && this.common.isEcorh && this.common.isDroitGestionHeureEcoRH &&
              !this.common.isPrestation, valuer: 0, icon: 'heure', col: 1, route: '/ecorh/heure'
          },
          {
            libelle: 'PAIE', droit: env.moduleEcorh && this.common.isEcorh && this.common.isExportPaie && !this.common.isPrestation, valuer: 0, icon: 'fact_paiement', col: 1, route: '/ecorh/paie'
          },
        ]
      },
      {
        libelle: 'Déchet', droit: env.moduleEcodechet && this.common.isEcodechet && !this.common.isPrestation, tuiles: [
          {
            libelle: 'Entrées', droit: env.moduleEcodechet && this.common.isEcodechet && !this.common.isPrestation,
            valuer: 'NBR_BON_ENTREE_ECODECHET_DU_JOUR', icon: 'dechet_entree', col: 1, route: '/ecodechet/entrees'
          },
          {
            libelle: 'Sorties', droit: env.moduleEcodechet && this.common.isEcodechet && !this.common.isPrestation,
            valuer: 'NBR_BON_SORTIE_ECODECHET_DU_JOUR', icon: 'dechet_sortie', col: 1, route: '/ecodechet/sorties'
          },
        ]
      },
      {
        libelle: 'Pol', droit: env.moduleEcopol && this.common.isEcopol && !this.common.isPrestation, tuiles: [
          {
            libelle: 'BAP', droit: env.moduleEcopol && this.common.isEcopol && !this.common.isPrestation,
            valuer: 'NBR_BAP_DU_JOUR', icon: 'contrat_fact', reverse: false, col: 1, route: '/ecopol/bap'
          },
        ]
      },
      {
        libelle: 'tri', droit: env.moduleEcotri && this.common.isEcotri, tuiles: [
          {
            libelle: 'Tri des entrées', droit: env.moduleEcotri && this.common.isTri,
            valuer: 'NBR_BAP_DU_JOUR', icon: 'tri_entree', reverse: false, col: 1, route: '/ecotri/entrees'
          },
          {
            libelle: 'Tri des sorties', droit: env.moduleEcotri && this.common.isTriSortie,
            valuer: 0, icon: 'tri_sortie', reverse: false, col: 1, route: '/ecotri/sortie'
          },
        ]
      },
      {
        libelle: 'Dec', droit: env.moduleEcodec && this.common.isEcodec && !this.common.isPrestation, tuiles: [
          {
            libelle: 'gestion des VHU', droit: env.moduleEcodec && this.common.isEcodec && !this.common.isPrestation,
            valuer: 'NBR_VHU_DU_JOUR', icon: 'voiture', reverse: false, col: 1, route: '/ecodec/vhu'
          },
          {
            libelle: 'Expédition', droit: env.moduleEcodec && this.common.isEcodec && !this.common.isPrestation,
            valuer: 0, icon: 'contrat_expedition', reverse: false, col: 1, route: '/ecodec/exp'
          }
        ]
      },
      {
        libelle: 'DD', droit: env.moduleEcodd && this.common.isEcodd && !this.common.isPrestation, tuiles: [
          {
            libelle: 'gestion des entrées', droit: env.moduleEcodd && this.common.isEcodd && !this.common.isPrestation,
            valuer: 'NBR_ENTREE_ECODD', icon: 'ecodd', reverse: false, col: 1, route: '/ecodd/entrees'
          },
          {
            libelle: 'Gestion du stock', droit: env.moduleEcodd && this.common.isEcodd && !this.common.isPrestation,
            valuer: 0, icon: 'stock', reverse: false, col: 1, route: '/ecodd/stock'
          },
          {
            libelle: 'Expédition', droit: env.moduleEcodd && this.common.isEcodd && !this.common.isPrestation,
            valuer: 0, icon: 'contrat_expedition', reverse: false, col: 1, route: '/ecodd/expedition'
          },
          {
            libelle: 'Retour BSD', droit: env.moduleEcodd && this.common.isEcodd && !this.common.isPrestation,
            valuer: 0, icon: 'dechet_sortie', reverse: false, col: 1, route: '/ecodd/bsd'
          },
        ]
      },
      {
        libelle: 'Stock', droit: env.moduleEcostock && this.common.isEcostock && !this.common.isPrestation, tuiles: [
          {
            libelle: 'gestion du stock', droit: this.common.isEcostockFact && this.common.isDroitGestionEcostock && !this.common.isPrestation,
            valuer: 'QTE_TOTAL_MATIERE_DERNIER_STOCK', icon: 'ecostock', reverse: false, col: 4, route: '/ecostock/stock'
          },
        ]
      }
    ];

    let totalLigne = 4;
    this.tuiles.forEach(elt => {
      const nbrVisible = ((elt.tuiles || []).filter(d => d.droit) || []).length;
      elt.nbrVisible = nbrVisible;
      if (nbrVisible > 0) {
        elt.tuiles.forEach(e => {
          if (nbrVisible % 2) {
            e.col = 1;
          } else {
            e.col = totalLigne / nbrVisible;
          }
        });
      }
    })
  }

  getValue(item) {
    this.data['TotalValidation'] = this.data['NOMBRE_BON_NON_VALIDES'] || 0;
    this.data['TotalRetourBon'] = this.data['NOMBRE_BON_ECOBENNE_NON_VALIDES'] || 0;
    return this.data[item] || 0;
  }

  totalRetourbon(): Number {
    let total = 0;
    this.barChartData[0].data.forEach(element => {
      total += parseInt(element, 10);
    });
    return total;
  }

  totalRetourbonEcobenne(): Number {
    let total = 0;
    this.barChartDataEcobenne[0].data.forEach(element => {
      total += parseInt(element, 10);
    });
    return total;
  }

  changeSite(event) {
    this.nomSite = event.nom || event.libelleObjetEntite;
    this.textSite = `<div class="tooloc">  ${this.nomSite} </div> ${this.icon}`;
    const infoUser = {
      login: this.user['login'],
      password: this.user['pwd'],
      site: event.id,
    };
    this.common.reloadValeurParDefaut();
    this.common.isLoadingApp = true;
    this.app['infoUser'] = infoUser;
    this.isChangeSite = true;
    
    // this.app.login(true);
    const param = {
      'servlet': 'DBGestionAngular',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 35
        },
        'CLEF_USER': {
          'typeParam': 'int',
          'valeur': this.user['id']
        },
        'SITE': '' + event.id
      }
    };

    return this.common.post('', { param: param }, false, true).then(datas => {
      console.log(datas)
      if (datas && datas.data) {
        const userInfo = this.common.local.getObject('userInfo');
        userInfo[3] = this.nomSite || '';
        userInfo[4] = datas.data;
        this.common.local.setObject('userInfo', userInfo);
      }
      this.app.loginFromHome();
    });
  }

  reloadMenu() {
    this.gridTuile();
    return this.common.isLoadingApp || false;
  }

  clickADVContrat() {
    this.common.defaultViewEcofact['adv'] = this.common.defaultViewEcofact['adv'] || {};
    this.common.defaultViewEcofact['adv'].nonConfSelected = this.nonConfSelected;
    this.common.defaultViewEcofact['adv'].isContrat = true;
  }

  loadParamAcces() {
    const societe = this.common.local.getObject('paramSociete') || {};
    this.paramHolding = this.common.local.getObject('paramHolding') || {};
    const listFormatPerso = this.common.getType('formaPerso');
    const listFormatCompta = this.common.getType('formaCompta');
    const isholding = this.common.local.get('isHolding');
    this.authorizedHoldingMenus = this.common.droitParamHolding;
    const droitHolding = isholding && this.common.droitParam['holding'];
    // const existeHoldingFamille = droitHolding && this.paramHolding['parametrageFamilleContenant'] ? true : false;
    const existeHoldingCubage = droitHolding && this.paramHolding['parametrageCubageContenant'] ? true : false;
    const existeHoldingFamilleArticle = droitHolding && this.paramHolding['parametrageFamilleArticle'] ? true : false;
    const existeHoldingSousFamilleArticle = droitHolding && this.paramHolding['parametrageSousFamilleArticle'] ? true : false;
    const existeHoldingTypeEquipement = droitHolding && this.paramHolding['parametrageTypeEquipement'] ? true : false;
    const afficherTypeEquipement = !(societe.isAppartientHolding && existeHoldingTypeEquipement); // Recylog.java ligne 2161
    this.common.listParamActive.forEach(elt => {
      switch (elt.id) {
        case 0:
          elt.submenus.forEach(elem => {
            switch (elem.id) {
              case 0:
                elem['droit'] = existeHoldingCubage ? false : this.common.droitParam['cubage'];
                break;
              case 1:
                elem['droit'] = this.common.droitParam['famille'];
                break;
              case 2:
                elem['droit'] = this.common.droitParam['typeCont'];
                break;
              case 3:
                elem['droit'] = this.common.droitParam['contenant'];
                break;
              case 4:
                elem['droit'] = this.common.droitParam['materiel'];
                break;
              case 5:
                elem['droit'] = this.common.droitParam['parking'];
                break;
              case 6:
                elem['droit'] = this.common.droitParam['periode'];
                break;
              case 7:
                elem['droit'] = this.common.droitParam['pontBascule'];
                break;
              case 8:
                elem['droit'] = this.common.droitParam['qualificationPersonnel'];
                break;
              case 9:
                elem['droit'] = this.common.droitParam['sousTypeEquipement'];
                break;
              case 10:
                elem['droit'] = this.common.droitParam['sousTypeMateriel'];
                break;
              case 11:
                elem['droit'] = this.common.droitParam['transporteur'];
                break;
              case 12:
                elem['droit'] = this.common.droitParam['typeEquipement'] && afficherTypeEquipement;
                break;
              case 13:
                elem['droit'] = this.common.droitParam['typeEquipementMateriel'];
                break;
              case 14:
                elem['droit'] = this.common.droitParam['typeMateriel'];
                break;
              case 15:
                elem['droit'] = this.common.droitParam['personnel'];
                break;
              case 16:
                elem['droit'] = this.common.droitParam['agenceInterim'];
                break;
              case 17:
                elem['droit'] = this.common.droitParam['operationBac'];
                break;
              case 18:
                elem['droit'] = this.common.droitParam['motifIndispo'];
                break;
              case 19:
                elem['droit'] = this.common.droitParam['fournisseur'];
                break;
              case 20:
                elem['droit'] = this.common.droitParam['mecanicien'];
                break;
              case 21:
                elem['droit'] = this.common.droitParam['articlesEntretien'];
                break;
              case 22:
                elem['droit'] = this.common.droitParam['equipementMateriel'];
                break;
              case 23:
                elem['droit'] = this.common.droitParam['typeReparation'];
                break;
              case 24:
                elem['droit'] = this.common.droitParam['programmeEntretien'];
                break;
              case 25:
                elem['droit'] = this.common.droitParam['typePropriete'];
                break;
              case 26:
                elem['droit'] = this.common.droitParam['zoneBac'];
                break;
              case 27:
                elem['droit'] = this.common.droitParam['zoneCommune'];
                break;
              case 28:
                elem['droit'] = this.common.droitParam['camera'];
                break;
              case 29:
                elem['droit'] = this.common.droitParam['motifMissionIntermaire'];
                break;
              case 30:
                elem['droit'] = this.common.droitParam['tourVehicule'];
                break
              case 31:
                elem['droit'] = this.common.droitParam['camionTransporteur'];
                break
              case 32:
                elem['droit'] = this.common.droitParam['cycleTravail'];
                break
              case 33:
                elem['droit'] = this.common.droitParam['modulation'];
                break
              case 34:
                elem['droit'] = this.common.droitParam['exutoire'];
                break
              case 35:
                elem['droit'] = this.common.droitParam['operationContenant'];
                break
              case 36:
                  elem['droit'] = this.common.droitParam['informatiqueEmbarque'];
                  break
              case 37:
                  elem['droit'] = this.common.droitParam['motif_refus_fip'];
              break    
            }
          });
          break;
        case 1:
          elt['droit'] = this.common.isPrestation ? true : false;
          break;
        case 2:
          elt['droit'] = this.common.isPrestation ? true : false;
          break;
        case 4: // Article
          elt.submenus.forEach(elem => {
            switch (elem.id) {
              case 0:
                elem['droit'] = this.common.droitParam['article'];
                break;
              case 1:
                elem['droit'] = existeHoldingFamilleArticle ? false : this.common.droitParam['familleArticle'];
                break;
              case 2:
                elem['droit'] = existeHoldingSousFamilleArticle ? false : this.common.droitParam['sousFamilleArticle'];
                break;
              case 3:
                elem['droit'] = this.common.droitParam['axeAnalytiqueArticle'];
                break;
            }
          });
          break;
        case 7:
          elt['droit'] = this.common.droitParam['champSupp'];
          break;
        case 8:
          elt['droit'] = this.common.droitParam['courtier'];
          break;
        case 11:
          elt['droit'] = this.common.droitParam['familleContrat'];
          break;
        case 12:
          elt['droit'] = this.common.droitParam['motifRefusDevis'];
          break;
        case 13: // Menu système
          elt.submenus.forEach(elem => {
            switch (elem.id) {
              case 0:
                elem['droit'] = this.common.droitParam['activiteSociete'];
                break;
              case 1:
                elem['droit'] = this.common.droitParam['compteSociete'];
                break;
              case 2:
                elem['droit'] = this.common.droitParam['profilUtilisateur'];
                break;
              case 3:
                elem['droit'] = this.common.droitParam['services'];
                break;
              case 4:
                elem['droit'] = this.common.droitParam['sites'];
                break;
              case 5:
                elem['droit'] = this.common.droitParam['societe'];
                break;
              case 6:
                elem['droit'] = this.common.droitParam['tva'];
                break;
              case 7:
                elem['droit'] = this.common.droitParam['utilisateur'];
                break;
              case 8:
                elem['droit'] = this.common.droitParam['typeDocument'];
                break;
              case 9:
                elem['droit'] = this.common.droitParam['typedepaiement'];
                break;
              case 10:
                elem['droit'] = this.common.droitParam['widgetEcoportail'];
                break;
              case 11:
                elem['droit'] = this.common.droitParam['compteEcoportail'];
                break;
              case 12:
                elem['droit'] = this.common.droitParam['paiementEnLigne'];
                break;
              case 13:
                elem['droit'] = this.common.droitParam['commune'];
                break;
              case 14:
                  elem['droit'] = this.common.droitParam['compteTrackDechets'];
                break;      
            }
          });
          break;
        case 14:
          elt['droit'] = this.common.droitParam['typeInstallation5Flux'];
          break;
        case 15: // Menu Décheterrie
          elt.submenus.forEach(elem => {
            switch (elem.id) {
              case 0:
                elem['droit'] = this.common.droitParam['dechetterie'];
                break;
              case 1:
                elem['droit'] = this.common.droitParam['dechetterie'];
                break;
            }

            // menu racine Déchetterie
            elt['droit'] = this.common.droitParam['dechetterie'];
          });

          break;
        case 16:
          elt['droit'] = this.common.droitParam['activiteDetenteur'];
          break;
        case 17:
          // elt['droit'] = this.common.droitParam['holding'];
          let subMenu = false;
          console.log("sub holding", this.paramHolding)
          console.log("sub authorizedHoldingMenus", this.authorizedHoldingMenus)
          elt.submenus.forEach(elem => {
            switch (elem.id) {
              case 0: // Utilisateurs holding
                elem['droit'] = this.authorizedHoldingMenus['accesToUtilisateur'] ? true : false;
                subMenu = elem['droit'];
                break;
              case 1: // article holding
                elem['droit'] = (this.paramHolding['parametrageArticle'] && this.authorizedHoldingMenus['accesToArticle']) ? true : false;
                subMenu = elem['droit'];
                break;
              case 2: // cubage de contenant holding
                elem['droit'] = (this.paramHolding['parametrageCubageContenant'] && this.authorizedHoldingMenus['accesToCubageContenant']) ? true : false;
                subMenu = elem['droit'];
                break;
              case 3: // exutoire holding
                elem['droit'] = (this.paramHolding['parametrageExutoire'] && this.authorizedHoldingMenus['accesToExutoire']) ? true : false;
                subMenu = elem['droit'];
                break;
              case 4: // famille d'article holding
                elem['droit'] = (this.paramHolding['parametrageFamilleArticle'] && this.authorizedHoldingMenus['accesToFamilleArticle']) ? true : false;
                subMenu = elem['droit'];
                break;
              case 5: // famille de contenant holding
                elem['droit'] = (this.paramHolding['parametrageFamilleContenant'] && this.authorizedHoldingMenus['accesToFamilleContenant']) ? this.paramHolding['parametrageFamilleContenant'] : false;
                subMenu = elem['droit'];
                break;
              case 6: // sous famille d'article holding
                elem['droit'] = (this.paramHolding['parametrageSousFamilleArticle'] && this.authorizedHoldingMenus['accesToSousFamilleArticle']) ?
                  true : false;
                subMenu = elem['droit'];
                break;
              case 7: // transporteur holding
                elem['droit'] = (this.paramHolding['parametrageTransporteur'] && this.authorizedHoldingMenus['accesToTransporteur']) ? true : false;
                subMenu = elem['droit'];
                break;
              case 8: // type de contenant holding
                elem['droit'] = (this.paramHolding['parametrageTypeContenant'] && this.authorizedHoldingMenus['accesToTypeContenant']) ? true : false;
                subMenu = elem['droit'];
                break;
              case 9: // client holding
                elem['droit'] = societe['gestionClientHolding'] && this.authorizedHoldingMenus['accesToClient'] ? true : false;
                subMenu = elem['droit'];
                break;
              case 10: // client matériel
                elem['droit'] = (this.paramHolding['parametrageCamion'] && this.authorizedHoldingMenus['accesToCamion']) ? true : false;
                subMenu = elem['droit'];
                break;
              case 11: // client courtier
                elem['droit'] = (this.paramHolding['parametrageCourtier'] && this.authorizedHoldingMenus['accesToCourtier']) ? true : false;
                subMenu = elem['droit'];
                break;
              case 12: // type d'équipement
                elem['droit'] = (this.paramHolding['parametrageTypeEquipement'] && this.authorizedHoldingMenus['accesToTypeEquipement']) ? true : false;
                subMenu = elem['droit'];
                break;
              case 13: // indices / indexes
                elem['droit'] = (this.paramHolding['parametrageIndice'] && this.authorizedHoldingMenus['accesToIndice']) ? this.paramHolding['parametrageIndice'] : false;
                subMenu = elem['droit'];
                break;
              // case 14: // Ponts bascule 
              //   elem['droit'] = this.authorizedHoldingMenus['accesToPontBascule'] ? true : false;
              //   subMenu = elem['droit'];
              //   break;
              default:
                elem['droit'] = this.common.droitParam['holding'];
                subMenu = elem['droit'];
            }
          });
          const existeSub = elt.submenus.filter(sub => sub.droit);
          console.log(isholding, this.common.droitParam['holding'], existeSub && existeSub.length)
          elt['droit'] = isholding && this.common.droitParam['holding'] && (existeSub && existeSub.length);
          break;
        case 18:
          elt.submenus.forEach(elem => {
            switch (elem.id) {
              case 0:
                elem['droit'] = this.common.droitParam['actionRDV'];
                break;
              case 1:
                elem['droit'] = this.common.droitParam['typeRDV'];
                break;
              case 2:
                elem['droit'] = this.common.droitParam['objectifRDV'];
                break;
            }

            elt['droit'] = this.common.droitParam['actionRDV'] || this.common.droitParam['typeRDV']
              || this.common.droitParam['objectifRDV'];
          });
          break;
        case 19:
          elt['droit'] = this.common.droitParam['broyeurs'];
          break;
        case 20:
          elt['droit'] = this.common.droitParam['centreVHU'];
          break;
        case 21:
          elt['droit'] = this.common.droitParam['rayonStock']
          break;
        case 22:
          elt['droit'] = this.common.droitParam['badgesPontBascule']
          break;
        case 23:
          elt['droit'] = this.common.droitParam['groupeClient'];
          break;
        case 24:
          elt['droit'] = this.common.droitParam['ressource'];
          break;
        case 25:
          elt['droit'] = this.common.droitParam['gestionNumeroCheque'];
          elt.submenus.forEach(elem => {
            elem['droit'] = this.common.droitParam['gestionNumeroCheque'];
          });
          break;
        case 26:
          elt.submenus.forEach(elem => {
            switch (elem.id) {
              case 0:
                elem['droit'] = this.common.droitParam['augPrixList'];
                break;
              case 1:
                elem['droit'] = this.common.droitParam['augPrixNeg'];
                break;
              case 2:
                elem['droit'] = this.common.droitParam['augPrixContrat'];
                break;
            }

            elt['droit'] = this.common.droitParam['augPrixList'] || this.common.droitParam['augPrixNeg'] || this.common.droitParam['augPrixContrat'] ? true : false;
          });
          break;

        case 27:
          elt.submenus.forEach(elem => {
            switch (elem.id) {
              case 0:
                elem['droit'] = this.common.droitParam['renouveCAP'];
                break;
              case 1:
                elem['droit'] = this.common.droitParam['impCAP'];
                break;
              case 2:
                elem['droit'] = this.common.droitParam['extraireCAP'];
                break;
              case 3:
                elem['droit'] = this.common.droitParam['impPersoCAP'];
                break;
              case 4:
                elem['droit'] = this.common.droitParam['renouvellementCapDnd'];
                break;
            }

            elt['droit'] = this.common.droitParam['renouveCAP'] || this.common.droitParam['impCAP']
              || this.common.droitParam['extraireCAP'] || this.common.droitParam['impPersoCAP'] || this.common.droitParam['renouvellementCapDnd'] ? true : false;
          });
          break;
        case 28:
          elt.submenus.forEach(elem => {
            switch (elem.id) {
              case 0:
                elem['droit'] = this.common.droitParam['ecoged'];
                break;
              case 1:
                elem['droit'] = this.common.droitParam['ecoged'];
                break;
              case 2:
                elem['droit'] = this.common.droitParam['qualificationDmd'];
                break;
              case 3:
                elem['droit'] = this.common.droitParam['questionnaireComposteur'];
                break;
            }

            elt['droit'] = (this.common.droitParam['ecoged'] || this.common.droitParam['qualificationDmd'] || this.common.droitParam['questionnaireComposteur']) ? true : false;
          });
          break;
        case 29:
          elt.submenus = [];
          listFormatPerso.forEach(format => {
            const formatAdd = Object.assign({}, format);
            formatAdd['title'] = formatAdd.libelleObjetEntite || '';
            formatAdd['route'] = '/recylog/param/formaPerso/' + (formatAdd.id || 0);
            formatAdd['visible'] = true;
            formatAdd['droit'] = this.common.droitParam['formatPerso'] ? true : false;
            elt.submenus.push(formatAdd);
          });

          elt['droit'] = this.common.droitParam['formatPerso'] ? true : false;
          break;

        case 30:
          elt.submenus.forEach(elem => {
            elem['droit'] = this.common.droitParam['formatCompta'] ? true : false;
          });
          elt['droit'] = this.common.droitParam['formatCompta'] ? true : false;
          break;
        case 31:
          elt['droit'] = this.common.droitParam['lieuxDepart'] ? true : false;
          break;
        case 32:
          elt['droit'] = this.common.droitParam['cycleTravail'] ? true : false;
          break;
        case 33:
          elt['droit'] = this.common.droitParam['sectionDevis'] ? true : false;

          console.log(this.common.droitParam['sectionDevis']);
          break;
        case 34:
          elt['droit'] = this.common.droitParam['frequenceImp'] ? true : false;
          break;
        case 35:
          elt['droit'] = this.common.droitParam['filiereFacturation'] ? true : false;
          break;
        case 36:
          elt['droit'] = true
          break;
        case 37:
          elt['droit'] = societe.isGestionCompteurRH ? true : false;
          break;
        case 38:
          elt['droit'] = this.common.droitParam['zoneStockage'] ? true : false;
          break;
        case 39:
          elt['droit'] = this.common.droitParam['populationCommune'] ? true : false;
          break;
        case 40:
          elt.submenus.forEach(elem => {
            switch (elem.id) {
              case 0:
                elem['droit'] = this.common.droitParam['activite'] ? true : false;
                break;
              case 1:
                elem['droit'] = this.common.droitParam['civilite'] ? true : false;
                break;
              case 2:
                elem['droit'] = this.common.droitParam['indice'] ? true : false;
                break;
              case 3:
                elem['droit'] = this.common.droitParam['indice'] ? true : false;
                break;
              case 4:
                elem['droit'] = this.common.droitParam['groupImp'] ? true : false;
                break;
            }

            elt['droit'] = this.common.droitParam['activite'] || this.common.droitParam['civilite']
              || this.common.droitParam['indice'] || this.common.droitParam['groupImp'] ? true : false;
          });
          break;
        case 41:
          elt['droit'] = this.common.droitParam['motifRefusEcoloc'] ? true : false;
          break;
        case 42:
          elt['droit'] = this.common.droitParam['motifRefusEcoloc'] ? true : true;
          break;
      }
    });

  }

}
